// Rename this file ffs.
// Would be real nice to change to functional lang but hopefully this is it
//
//
//
//
function toggleHideClasses(id, classOne, classTwo) {
  let el = document.getElementById(id);

  if (el) {
    el.classList.toggle(classOne);
    el.classList.toggle(classTwo);
  }
}

function toggleHideAndFocus(id) {
  toggleHideId(id);
  focusId(id);
}

function toggleHideId(id) {
  let el = document.getElementById(id);

  if (el) {
    el.classList.toggle("hidden");
  }
}

function toggleHide(event) {
  let el = event.currentTarget;

  if (el) {
    el.classList.toggle("hidden");
  }
}

function toggleHideNext(event) {
  let el = event.currentTarget;

  if (el) {
    let next = el.nextElementSibling;
    if (next) {
      next.classList.toggle("hidden");
    }
  }
}

function toggleHideNextContains(event, str_class) {
  let el = event.currentTarget;

  if (el && !el.contains(event.relatedTarget)) {
    let childContaining = el.querySelector(`${str_class}`);
    if (childContaining) {
      childContaining.classList.toggle("hidden");
    }
  }
}

function toggleHideParent(event) {
  let el = event.currentTarget;

  if (el) {
    let next = el.parentElement;
    if (next) {
      next.classList.toggle("hidden");
    }
  }
}

function toggleHideBlurFromChild(event) {
  let el = event.currentTarget;

  if (!el.contains(event.relatedTarget)) {
    el.classList.toggle("hidden");
  }
}

function addTabIndexToSibling(e) {
  let el = e.currentTarget;
  if (el) {
    let next = el.nextElementSibling;
    if (next && next.classList.contains("hidden-event-el")) {
      next.tabIndex = "0";
    }
  }
}

function addNewPreviousEl(e) {
  let el = e.currentTarget;
  if (el) {
    let previous = el.previousElementSibling;
    if (previous && previous.value.trim() == "") {
      el.tabIndex = "-1";
      focusNextQuestionInput(e);
    } else {
      el.previousElementSibling.focus();
      el.previousElementSibling.value = "";
      setTimeout(function () {
        el.tabIndex = "0";
      }, 100);
    }
  }
}

function addNew(e) {
  let el = e.currentTarget;
  if (el) {
    if (el.value && el.value.trim() == "") {
      focusNextQuestionInput(e);
    } else {
      let next = el.nextElementSibling;
      if (next) {
        next.focus();
      }
    }
  }
}

function focusId(id) {
  let el = document.getElementById(id);

  if (el) {
    el.focus();
  }
}

function addNewKeepEl(id) {
  setTimeout(function () {
    focusId(id);
  }, 100);
}

function onlyNumberKey(event) {
  // Only ASCII character in that range allowed
  var ASCIICode = event.which ? event.which : event.keyCode;
  if (ASCIICode > 31 && (ASCIICode < 48 || ASCIICode > 57)) return false;
  return true;
}

function incompletionGoToFirstIncomplete() {
  let el = document.querySelector(".is-unanswered");
  if (el) {
    let input = el.querySelector(".input-question");

    if (input) {
      input.focus();
    }
  }
}

function focusNextQuestionParent(e) {
  let el = e.currentTarget;
  if (el) {
    let parent = el.closest(".question-parent");

    if (parent) {
      let next = parent.nextElementSibling;
      if (next) {
        let input = next.querySelector(".input-question");

        if (input) {
          next.scrollIntoView({
            behavior: "smooth",
            block: "start",
            inline: "nearest",
          });
          setTimeout(function () {
            input.focus({ preventScroll: true });
          }, 200);
        } else {
          let complete = document.getElementById("complete-form");

          if (complete == null) {
            complete = document.getElementById("complete-approval-form");
          }

          if (complete) {
            setTimeout(function () {
              complete.focus();
            }, 100);
          }
        }
      }
    }
  }
}

function focusSecondSibling(e) {
  let el = e.currentTarget;
  if (el) {
    let parent = el.closest(".section-parent");

    if (parent) {
      let next = parent.nextElementSibling;

      if (next) {
        let newNext = next.nextElementSibling;

        if (newNext) {
          let input = newNext.querySelector(".section-button");

          if (input) {
            input.focus();
          } else {
            parent = el.closest(".question-parent");
            input = parent.querySelector(".input-question");
            if (input) {
              input.focus();
            }
          }
        }
      }
    }
  }
}

function focusNextQuestionInput(e) {
  let el = e.currentTarget;
  if (el) {
    let parent = el.closest(".question-parent");

    if (parent) {
      let next = parent.nextElementSibling;
      if (next) {
        let input = next.querySelector(".input-question");
        if (input) {
          input.focus();
        } else {
          let complete = document.getElementById("complete-form");
          if (complete) {
            complete.focus();
          }
        }
      }
    }
  }
}

function removeValue(event) {
  let el = event.currentTarget;
  if (el) {
    el.value = "";
  }
}

function onEnterFocusHiddenEl(event) {
  if (event.keyCode === 13) {
    let el = event.currentTarget;
    if (el) {
      let next = el.nextElementSibling;
      if (next && next.classList.contains("hidden-event-el")) {
        next.focus();
      }
    }
  }
}

function stopPropagation(event) {
  event.stopPropagation();
}

function onEnterStopPropagation(event) {
  if (event.keyCode === 13) {
    event.stopPropagation();
  }
}

function preventDefault(event) {
  event.preventDefault();
}

function preventDefaultStopPropagation(event) {
  event.preventDefault();
  event.stopPropagation();
}

function onEnterPreventDefault(event) {
  if (event.keyCode === 13) {
    event.preventDefault();
  }
}

function onEnterFocusNext(event) {
  if (event.keyCode === 13) {
    let el = event.currentTarget;
    if (el && el.value.trim() != "") {
      focusNextQuestionInput(event);
    }
  }
}

// When the user clicks on the button, open the modal
function acceptModal(modalId) {
  let el = document.getElementById(modalId);

  if (el) {
    el.style.display = "none";
  }
}

// Only works if opened by _blank anchor tag
function declineModal(e) {
  console.log("Please leave");
}

export function togglePlayPause(e, id) {
  var video = document.getElementById(id);

  if (video.paused) {
    video.play();
    e.target.innerHTML = `<div id="inner-pause-${id}" class="flex items-center justify-center">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="white" class="w-6 h-6">
          <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 5.25v13.5m-7.5-13.5v13.5" />
        </svg>
      </div>`;
  } else {
    video.pause();
    e.target.innerHTML = `<div id="inner-play-${id}" class="flex items-center justify-center">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="white" class="w-6 h-6">
          <path stroke-linecap="round" stroke-linejoin="round" d="M5.25 5.653c0-.856.917-1.398 1.667-.986l11.54 6.347a1.125 1.125 0 0 1 0 1.972l-11.54 6.347a1.125 1.125 0 0 1-1.667-.986V5.653Z" />
        </svg>
      </div>`;
  }
}

function focusFirstInputAndScrollIntoView(id, focusId) {
  var el = document.getElementById(id);

  if (el) {
    el.scrollIntoView({
      behavior: "smooth",
      block: "center",
      inline: "nearest",
    });
  }

  var focusEl = document.getElementById(
    `inline-form-${focusId}_answers_0_answer`,
  );

  if (focusEl) {
    focusEl.focus();
  }
}

function scrollIntoView(id) {
  var el = document.getElementById(id);

  if (el) {
    el.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
  }
}

function enforceDollars(event) {
  let val = parseFloat(event.target.value);
  let payHolder = document.getElementById("payment-types-holder");
  let payMsg = document.getElementById("payment-amount-msg");
  let answerForReal = document.getElementById("answer-form-field");

  if (isNaN(val)) {
    if (payHolder) {
      payHolder.classList.add("hidden");
      payMsg.classList.remove("hidden");
    }

    if (answerForReal) {
      answerForReal.value = "";
    }
  } else {
    event.target.value = val.toFixed(2);

    if (payHolder) {
      if (val > 1) {
        payHolder.classList.remove("hidden");
        payMsg.classList.add("hidden");
        if (answerForReal) {
          answerForReal.value = val.toFixed(2);
        }
      } else {
        payHolder.classList.add("hidden");
        payMsg.classList.remove("hidden");

        if (answerForReal) {
          answerForReal.value = "";
        }
      }
    }
  }
}

export default {
  toggleMultiselect,
  updateMultiselect,
  initMultiselects,
  refreshMultiselectSummary,
  enforceDollars,
  focusFirstInputAndScrollIntoView,
  scrollIntoView,
  togglePlayPause,
  toggleHideAndFocus,
  focusId,
  toggleHideClasses,
  toggleHideId,
  acceptModal,
  declineModal,
  stopPropagation,
  preventDefault,
  preventDefaultStopPropagation,
  toggleHide,
  toggleHideNext,
  toggleHideNextContains,
  toggleHideParent,
  toggleHideBlurFromChild,
  onEnterStopPropagation,
  onEnterPreventDefault,
  addTabIndexToSibling,
  onEnterFocusHiddenEl,
  onEnterFocusNext,
  removeValue,
  addNew,
  addNewPreviousEl,
  onlyNumberKey,
  incompletionGoToFirstIncomplete,
  focusNextQuestionInput,
  focusNextQuestionParent,
  focusSecondSibling,
};

// --- Multiselect (checkbox dropdown) ---------------------------------------
//
// These run on dead (non-LiveView) pages too, so they use plain DOM listeners
// rather than phx-click JS commands.

function multiselectRoot(el) {
  return el && el.closest("[data-multiselect]");
}

function multiselectBoxes(root) {
  return Array.from(root.querySelectorAll("input[type=checkbox]"));
}

function multiselectSelected(root) {
  return multiselectBoxes(root)
    .filter((box) => box.checked)
    .map((box) => box.value);
}

function openMultiselect(root) {
  let panel = root.querySelector("[data-multiselect-panel]");
  let trigger = root.querySelector("[data-multiselect-trigger]");

  if (panel) {
    panel.classList.remove("hidden");
  }
  if (trigger) {
    trigger.setAttribute("aria-expanded", "true");
  }
}

function closeMultiselect(root) {
  let panel = root.querySelector("[data-multiselect-panel]");
  let trigger = root.querySelector("[data-multiselect-trigger]");

  if (panel) {
    panel.classList.add("hidden");
  }
  if (trigger) {
    trigger.setAttribute("aria-expanded", "false");
  }
}

function toggleMultiselect(el) {
  let root = multiselectRoot(el);
  if (!root) {
    return;
  }

  let panel = root.querySelector("[data-multiselect-panel]");

  if (panel && panel.classList.contains("hidden")) {
    openMultiselect(root);
  } else {
    closeMultiselect(root);
  }
}

function refreshMultiselectSummary(root) {
  let summary = root.querySelector("[data-multiselect-summary]");
  if (!summary) {
    return;
  }

  let selected = multiselectSelected(root);

  if (selected.length === 0) {
    summary.textContent = root.dataset.multiselectPlaceholder || "";
  } else if (selected.length <= 2) {
    summary.textContent = selected.join(", ");
  } else {
    summary.textContent = `${selected.length} selected`;
  }

  summary.classList.toggle("text-violet-900/50", selected.length === 0);
}

function setMultiselectError(root, message) {
  let holder = root.querySelector("[data-multiselect-error]");
  let trigger = root.querySelector("[data-multiselect-trigger]");

  if (holder) {
    if (message) {
      let text = holder.querySelector("[data-multiselect-error-text]");
      if (text) {
        text.textContent = message;
      }
      holder.classList.remove("hidden");
    } else {
      holder.classList.add("hidden");
    }
  }

  if (trigger) {
    trigger.classList.toggle("border-red-700", !!message);
    trigger.classList.toggle("focus:border-red-700", !!message);
    trigger.classList.toggle("border-indigo-900", !message);
  }
}

function updateMultiselect(checkbox) {
  let root = multiselectRoot(checkbox);
  if (!root) {
    return;
  }

  refreshMultiselectSummary(root);

  if (multiselectSelected(root).length > 0) {
    setMultiselectError(root, null);
  }
}

// Checkbox groups cannot be validated natively while their panel is display:none
// (the browser refuses to report validity on an unfocusable control), so the
// "at least one option" rule for required questions is enforced here.
function validateMultiselects(form) {
  let firstInvalid = null;

  form
    .querySelectorAll('[data-multiselect][data-multiselect-required="true"]')
    .forEach((root) => {
      let answered = multiselectSelected(root).length > 0;

      setMultiselectError(
        root,
        answered ? null : "Please select at least one option.",
      );

      if (!answered && !firstInvalid) {
        firstInvalid = root;
      }
    });

  return firstInvalid;
}

function initMultiselects() {
  let refreshAll = () => {
    document
      .querySelectorAll("[data-multiselect]")
      .forEach((root) => refreshMultiselectSummary(root));
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", refreshAll);
  } else {
    refreshAll();
  }

  document.addEventListener("click", (e) => {
    document.querySelectorAll("[data-multiselect]").forEach((root) => {
      if (!root.contains(e.target)) {
        closeMultiselect(root);
      }
    });
  });

  document.addEventListener(
    "submit",
    (e) => {
      let form = e.target;
      if (!form || typeof form.querySelectorAll !== "function") {
        return;
      }

      let firstInvalid = validateMultiselects(form);

      if (firstInvalid) {
        e.preventDefault();
        e.stopPropagation();
        openMultiselect(firstInvalid);
        firstInvalid.scrollIntoView({
          behavior: "smooth",
          block: "center",
          inline: "nearest",
        });
      }
    },
    true,
  );
}
